import type {TabProp} from '@jobseeker/lotus/components/Nav/types';

export const getFilteredCategoryList = (tabsList: TabProp[]) => {
  return tabsList.reduce<TabProp[]>((result, tab) => {
    if (tab.menu && Array.isArray(tab.menu) && tab.label !== 'AI/ML') {
      // Extract first-level menu items
      tab.menu.forEach(item => {
        result.push({
          label: item.label,
          dataId: item.dataId,
          tag: item.tag,
          link: item.link,
          menu: item.menu || [], // Keep nested menu if available
        });
      });
    } else {
      result.push({...tab});
    }
    return result;
  }, []);
};
